"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var reactjs_popup_1 = __importDefault(require("reactjs-popup"));
var queries_1 = require("../../components/LanguageSelector/Graphql/queries");
var localStorage_1 = __importDefault(require("../../config/localStorage"));
var country_hook_1 = require("../../context/CountryContext/country.hook");
var general_1 = require("../../lib/general");
var icons_1 = __importDefault(require("../../theme/icons"));
function LanguageContainer(props) {
    var _a = (0, react_1.useState)([]), languages = _a[0], setLanguages = _a[1], _b = (0, react_1.useState)(""), language = _b[0], setLanguage = _b[1], i18n = (0, react_i18next_1.useTranslation)().i18n;
    var ref = (0, react_1.useRef)(), closeTooltip = function () { return ref.current.close(); };
    var country = (0, country_hook_1.useCountry)().country;
    var _c = (0, client_1.useLazyQuery)(queries_1.GET_LANGUAGES), calllaguages = _c[0], responselanagues = _c[1];
    (0, react_1.useEffect)(function () {
        calllaguages({ variables: { country_code: country } });
    }, [country]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if ((_a = responselanagues === null || responselanagues === void 0 ? void 0 : responselanagues.data) === null || _a === void 0 ? void 0 : _a.getLanguage) {
            init((_b = responselanagues === null || responselanagues === void 0 ? void 0 : responselanagues.data) === null || _b === void 0 ? void 0 : _b.getLanguage);
        }
    }, [responselanagues]);
    function handleChange(value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        closeTooltip();
                        setLanguage(value);
                        return [4 /*yield*/, localStorage_1.default.setItem("language", value)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, i18n.changeLanguage(value)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function init(response) {
        return __awaiter(this, void 0, void 0, function () {
            var tmp, storeLang;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tmp = [];
                        response.map(function (l) {
                            var code = l.code, id = l.id, name = l.name;
                            tmp.push({
                                id: id,
                                label: (0, general_1.capitalize)(name),
                                value: code.toLowerCase(),
                            });
                        });
                        setLanguages(tmp);
                        return [4 /*yield*/, localStorage_1.default.getItem("language")];
                    case 1:
                        storeLang = _a.sent();
                        return [4 /*yield*/, i18n.changeLanguage(storeLang ? storeLang : "en")];
                    case 2:
                        _a.sent();
                        setLanguage(storeLang ? storeLang : "en");
                        return [2 /*return*/];
                }
            });
        });
    }
    return (react_1.default.createElement("div", { className: "profile-name" },
        react_1.default.createElement(reactjs_popup_1.default, { arrow: true, closeOnDocumentClick: true, 
            // OverlayStyle={{ zIndex: 9999 }}
            contentStyle: { zIndex: 9999 }, 
            // ClassName={"language"}
            position: "left top", ref: ref, trigger: react_1.default.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                } },
                react_1.default.createElement("div", { className: "headerText ".concat(props.className) }, language.toUpperCase()),
                react_1.default.createElement("div", { style: {
                        transform: "rotate(270deg)",
                        marginLeft: "0.5rem",
                    } },
                    react_1.default.createElement(icons_1.default, { className: props.iconClassName, height: 20, name: "backArrow", width: 20 }))) },
            react_1.default.createElement("div", { className: "language-content" }, languages.length > 0 &&
                languages.map(function (l, i) { return (react_1.default.createElement("div", { key: i, onClick: function () { return handleChange(l.value); }, style: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                    } },
                    react_1.default.createElement("a", { className: "headerText", style: { padding: "0.4rem" } }, l.value.toUpperCase()),
                    react_1.default.createElement("a", { className: "headerText", style: {
                            padding: "0.4rem",
                        } }, (0, general_1.capitalize)(l.label)))); })))));
}
LanguageContainer.propTypes = {
    error: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    style: prop_types_1.default.object,
    className: prop_types_1.default.string,
    iconClassName: prop_types_1.default.string,
};
exports.default = LanguageContainer;
